<div
  class="
    chatbot-composer
    d-flex flex-column align-items-stretch gap-2
    px-3 py-2
    border-top border-light border-opacity-10
    rounded-bottom-4
  "
>
  <div
    v-if="show_compare_selector"
    class="chatbot-compare-drawer"
    :class="{ 'is-open': is_compare_drawer_open }"
  >
    <button
      type="button"
      class="chatbot-compare-drawer-toggle"
      :disabled="disabled"
      :aria-expanded="is_compare_drawer_open ? 'true' : 'false'"
      aria-controls="chatbot-compare-drawer-panel"
      @click="toggle_compare_drawer"
    >
      <span class="chatbot-compare-drawer-title">
        <i class="bi bi-buildings" aria-hidden="true"></i>
        <span>Properties</span>
      </span>
      <span class="chatbot-compare-drawer-meta">
        <span class="chatbot-compare-count">{{ selected_compare_property_count_label }}</span>
        <i :class="is_compare_drawer_open ? 'bi bi-chevron-down' : 'bi bi-chevron-up'" aria-hidden="true"></i>
      </span>
    </button>

    <div
      v-if="is_compare_drawer_open"
      id="chatbot-compare-drawer-panel"
      class="chatbot-compare-drawer-panel"
    >
      <div class="chatbot-compare-drawer-actions">
        <span class="chatbot-compare-drawer-summary">{{ selected_compare_property_summary }}</span>
        <span class="d-inline-flex align-items-center gap-1">
          <button
            type="button"
            class="chatbot-compare-action-btn"
            :disabled="disabled || all_compare_properties_selected"
            @click="select_all_compare_properties"
          >
            All
          </button>
          <button
            type="button"
            class="chatbot-compare-action-btn"
            :disabled="disabled || !normalized_compare_property_ids().length"
            @click="clear_compare_properties"
          >
            Clear
          </button>
        </span>
      </div>

      <div class="chatbot-compare-property-grid">
        <label
          v-for="property in compare_property_options"
          :key="property.id"
          class="chatbot-compare-property-option"
          :class="{ 'is-selected': is_compare_property_selected(property.id) }"
          :for="`compare-property-${property.id}`"
        >
          <input
            class="form-check-input m-0"
            type="checkbox"
            :id="`compare-property-${property.id}`"
            :checked="is_compare_property_selected(property.id)"
            :disabled="disabled"
            @change="toggle_compare_property(property.id)"
          />
          <span>{{ property.label }}</span>
        </label>
      </div>
    </div>
  </div>

  <div class="d-flex align-items-center gap-2 w-100">
    <input
      type="text"
      :value="model_value"
      :disabled="disabled"
      @input="$emit('update:model_value', $event.target.value)"
      @keyup.enter="$emit('send')"
      class="
        form-control
        bg-white bg-opacity-10
        text-white
        border-0
        rounded-3
        shadow-none
      "
      :placeholder="placeholder"
    />

    <button
      class="btn btn-primary rounded-circle d-inline-flex align-items-center justify-content-center p-0 chatbot-send-btn"
      :disabled="disabled"
      @click="$emit('send')"
      aria-label="Send message"
    >
      <i class="bi bi-send-fill"></i>
    </button>
  </div>
</div>
